/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface VoiceAgentInferencerLiveKit
 */
export interface VoiceAgentInferencerLiveKit {
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerLiveKit
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKit
   */
  name?: string | null;
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerLiveKit
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof VoiceAgentInferencerLiveKit
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof VoiceAgentInferencerLiveKit
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKit
   */
  serverUrl: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKit
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKit
   */
  agentName: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKit
   */
  dispatchMetadata?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerLiveKit
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerLiveKit
   */
  maxDuration?: number;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerLiveKit
   */
  maxConcurrency?: number;
}

/**
 * Check if a given object implements the VoiceAgentInferencerLiveKit interface.
 */
export function instanceOfVoiceAgentInferencerLiveKit(value: object): value is VoiceAgentInferencerLiveKit {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('serverUrl' in value) || value['serverUrl'] === undefined) return false;
  if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
  if (!('agentName' in value) || value['agentName'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerLiveKitFromJSON(json: any): VoiceAgentInferencerLiveKit {
  return VoiceAgentInferencerLiveKitFromJSONTyped(json, false);
}

export function VoiceAgentInferencerLiveKitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerLiveKit {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    serverUrl: json['server_url'],
    apiKey: json['api_key'],
    agentName: json['agent_name'],
    dispatchMetadata: json['dispatch_metadata'] == null ? undefined : json['dispatch_metadata'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
    maxConcurrency: json['max_concurrency'] == null ? undefined : json['max_concurrency'],
  };
}

export function VoiceAgentInferencerLiveKitToJSON(
  value?: Omit<VoiceAgentInferencerLiveKit, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    server_url: value['serverUrl'],
    api_key: value['apiKey'],
    agent_name: value['agentName'],
    dispatch_metadata: value['dispatchMetadata'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
    max_concurrency: value['maxConcurrency'],
  };
}
